// extracted by mini-css-extract-plugin
module.exports = {"posts":"Blog-module--posts--28g0T"};